


















import traceQuery from '~/queries/trace.gql'
import contentQuery from '~/queries/trace-content.gql'

export default

	props:
		traceData: Object
		contentMap: Object

	data: ->
		loaded: false
		sectionData: {}
		uniqueContent: {}
		optionalProduct: {}
		tableHeading: [
			{
				title: 'Product'
			},
			{
				title: 'Harvest Season'
			},
			{
				title: 'Bottled'
			}
		]

	fetch: ->
		@sectionData = await @$craft.getEntry
			query: traceQuery
			variables:
				section: 'trace'
				type: 'marquee'
				slug: 'marquee'

		slug = ''
		if @desc.includes 'COR Rstd Garlic EVOO Chef' then slug = 'garlic-evoo-chefs-bottle-250ml'
		else if @desc.includes 'COR Rstd Garlic EVOO Blend' then slug = 'garlic-evoo-glass-bottle-750ml'
		else if @desc.includes 'COR Jalapeno Herb EVOO' then slug = 'jalapeño-herb-flavored-evoo-chefs-bottle-250ml'
		else if @desc.includes 'COR Black Truffle EVOO' then slug = 'black-truffle-flavored-evoo-chefs-bottle-250-ml'
		else if @desc.includes '100%' then slug = '100-california'
		else if @desc.includes 'Global Medium' then slug = 'global-medium'
		else if @desc.includes 'Global Mild' then slug = 'global-mild'
		else if @desc.includes 'Global Robust' then slug = 'global-robust'

		content = await @$craft.execute
			query: contentQuery
			variables:
				slug: slug

		@uniqueContent = content?.category
		@$emit 'update', @uniqueContent.product
		@loaded = true

	computed:

		table: -> {
			"heading": @tableHeading
			"data": @tableData
		}

		tableData: -> [
			{
				cell1: @column
				cell2: @harvestYear
				cell3: @formattedDate
			}
		]
		date: -> new Date(@traceData?.BottleDate?.date)

		formattedDate: -> "#{(@date?.getMonth() + 1).toString().padStart(2, '0')}/#{@date?.getDate().toString().padStart(2, '0')}/#{@date?.getFullYear()}";


		desc: -> @traceData?.ItemDesc

		title: -> @uniqueContent?.title
		image: -> @uniqueContent?.image
		column: -> @uniqueContent?.column
		body: -> @uniqueContent?.body
		product: -> @uniqueContent?.product
		collection: -> @uniqueContent?.collection

		shopAllLabel: -> 'Shop & Save 15% with Subscription'

		productButton: -> {
			label: 'Quick Shop'
			product: @product[0]
		}

		harvestYear: ->
			if @traceData.countries?.length > 1
				years = @traceData.countries?.map (item) ->
					item.HY
				uniqYears = [...new Set years]
				return uniqYears.join ', '
			else return  @traceData.countries?[0]?.HY

		block: -> {
			id: @sectionData.id
			backgroundColor: '#F8F8F6'
			buttons: []
			customTitle: @title
			componentName: 'blocks-half-marquee'
			foregroundImage: []
			icon: []
			image: @image
			layout: 'left'
			showLines: false
			video: null
			videoLabel: null
			videoUrl: null
			table: @table
			optionalProduct: @product?[0]
			optionalCollection: @collection?[0]
			copy: [
				@body
			].join ' '
		}

	methods:
		reset: -> @$emit 'reset'

